import { inject } from '@angular/core';
import { EngineReportDetails } from '@navstation-portal/reporting/data-model/engine-report';
import { injectDispatch } from '@ngrx/signals/events';
import { engineReportEvents } from '../../engine-report-events';
import { EngineReportStore } from '../../engine-report.store';

export type DetailsFieldChangeHandler = <K extends keyof EngineReportDetails>(
  field: K,
  value: EngineReportDetails[K]
) => void;

export type SwashPlateChangeHandler = (index: number, value: number | undefined) => void;

/**
 * Must be called from an injection context (e.g. a component field initializer),
 * same as `injectDispatch` itself.
 */
export function injectDetailsFieldChangeHandler(): DetailsFieldChangeHandler {
  const dispatch = injectDispatch(engineReportEvents);

  return <K extends keyof EngineReportDetails>(field: K, value: EngineReportDetails[K]): void => {
    dispatch.updateReportDetails({ [field]: value } as Partial<EngineReportDetails>);
  };
}

/**
 * Updates a single index of `swashPlates`, leaving the other swash plates untouched.
 * Must be called from an injection context, same as `injectDetailsFieldChangeHandler`.
 */
export function injectSwashPlateChangeHandler(): SwashPlateChangeHandler {
  const engineReportStore = inject(EngineReportStore);
  const onDetailsFieldChange = injectDetailsFieldChangeHandler();

  return (index: number, value: number | undefined): void => {
    const swashPlates = [...(engineReportStore.details().swashPlates ?? [])];
    swashPlates[index] = value;
    onDetailsFieldChange('swashPlates', swashPlates);
  };
}
